import api from './api';

export interface MqttIntegration {
  id: number;
  company_id: string;
  app_name: string;
  third_party_team_id: string;
  bridge_client_id: string;
  status: 'active' | 'revoked';
  created_at: string;
}

export interface MqttTopics {
  commandTopic: string;
  eventsTopic: string;
  stateTopic: string;
}

export interface CreateMqttIntegrationResponse {
  integration: MqttIntegration;
  topics: MqttTopics;
}

export async function getMqttIntegrations(companyId: string): Promise<MqttIntegration[]> {
  const response = await api.get<MqttIntegration[]>('/v1/integrations/mqtt', {
    params: { company_id: companyId },
  });
  return response.data;
}

export async function createMqttIntegration(
  companyId: string,
  appName: string,
  thirdPartyTeamId: string,
  thirdPartyApiKey: string,
): Promise<CreateMqttIntegrationResponse> {
  const response = await api.post<CreateMqttIntegrationResponse>('/v1/integrations/mqtt', {
    company_id: companyId,
    app_name: appName,
    third_party_team_id: thirdPartyTeamId,
    third_party_api_key: thirdPartyApiKey,
  });
  return response.data;
}

export async function updateMqttIntegration(
  companyId: string,
  id: number,
  thirdPartyTeamId: string,
  thirdPartyApiKey: string,
  appName?: string,
): Promise<CreateMqttIntegrationResponse> {
  const response = await api.put<CreateMqttIntegrationResponse>(`/v1/integrations/mqtt/${id}`, {
    company_id: companyId,
    app_name: appName,
    third_party_team_id: thirdPartyTeamId,
    third_party_api_key: thirdPartyApiKey,
  });
  return response.data;
}

export async function revokeMqttIntegration(companyId: string, id: number): Promise<void> {
  await api.delete(`/v1/integrations/mqtt/${id}`, {
    data: { company_id: companyId },
  });
}

export interface MqttConnectionStatus {
  connected: boolean;
  reconnecting: boolean;
  error: string | null;
}

export async function getMqttIntegrationStatuses(
  companyId: string,
): Promise<Record<number, MqttConnectionStatus>> {
  const response = await api.get<Record<number, MqttConnectionStatus>>(
    '/v1/integrations/mqtt/status',
    { params: { company_id: companyId } },
  );
  return response.data;
}
